import React, {Fragment, useEffect, useRef, useState} from 'react';
import {modal, cart} from "actions";
import {useDispatch, useSelector} from "react-redux";

import Portal from 'common/components/Portal';
import isMobile from 'common/helpers/isMobile';
import {t} from 'translates';
import LazyLoadImageComponent from "common/components/LazyLoadImage";

import Session from './components/Session';
import classNames from "classnames";
import {addToCart, initAnalyticsValues} from "../product-reservation/ProductReservation";

function AvailableSessionsModal() {
  const dispatch = useDispatch();
  const modalData = useSelector((state) => state.availableSessionsModal);
  const state = useSelector((state) => state);
  const [analyticsValue, setAnalyticsValue] = useState(null);
  const [currentSession, setCurrentSession] = useState({id: null, date: null, time: null});
  const bookCtaLabel = window.drupalSettings && window.drupalSettings.bookCtaLabel && window.drupalSettings.bookCtaLabel.length > 0 ? window.drupalSettings.bookCtaLabel : '';
  const productWrapperRef = useRef();

  const close = () => {
    setCurrentSession({id: null, date: null, time: null});
    dispatch(modal.hide('available.dialog'));
    return false;
  };

  const addToCartHandler = (e, productWrapperRef) => {
    e.preventDefault();
    close();
    addToCart(1, currentSession.id, dispatch, state.availableSessionsModal, productWrapperRef, analyticsValue);
  };

  useEffect(() => {
    initAnalyticsValues(modalData.id, setAnalyticsValue);
  }, [modalData]);

  return (
    <Fragment>
      <Portal
        id="available.dialog"
        className="reservation-dialog__portal"
        onClose={close}
        isOpen
        ref={productWrapperRef}
      >
        <div className={classNames(`available-sessions`, {
          "available-sessions--mobile": isMobile
        })}>
          <button className="available-sessions__close" onClick={close}/>
          {!isMobile && (
            <div className="available-sessions__image">
              <LazyLoadImageComponent
                src={modalData.image.uri}
                alt={modalData.image.alt}
              />
            </div>
          )}
          <div className="available-sessions__body">
            <div className="available-sessions__header"
                 style={{backgroundImage: `${isMobile && `url(${modalData.image.image_desktop})`}`}}>
              <span className="available-sessions__category" style={{backgroundColor: modalData.color}}>
                {modalData.category}
              </span>
              <div className="available-sessions__header-inner">
                <div className="available-sessions__header-inner-left">
                  <h2 className='available-sessions__title'>
                    {modalData.title}
                  </h2>
                  {!isMobile && (
                    <p className="available-sessions__desk">
                      {modalData.description}
                    </p>
                  )}
                </div>
                {!isMobile && (
                  <a className='available-sessions__cta' href={modalData.cta.url}>{modalData.cta.label}</a>
                )}
              </div>
              <span className='available-sessions__price'>
                {modalData.price_string}
              </span>
            </div>
            <div className="available-sessions__list">
              {modalData.sessions.length > 0 && (
                <span className="available-sessions__list-select-session">{t('Select a session', DT_SESSIONS)}</span>
              )}
              <span className="available-sessions__list-title">
                {modalData.sessions_available_label}
              </span>
              <div className="available-sessions__list-inner">
                {modalData.sessions.map((item) => (
                  <Session setCurrentSession={setCurrentSession} currentSession={currentSession}
                           key={item.id} {...item}/>
                ))}
              </div>
            </div>
            {currentSession.id !== null && (
              <a href="#" onClick={(e) => addToCartHandler(e, productWrapperRef)}
                 className='available-sessions__submit'>
                {(bookCtaLabel.length > 0) ? bookCtaLabel : t('Book now', DT_SESSIONS)}
              </a>
            )}
          </div>
        </div>
      </Portal>
    </Fragment>
  );
}

export default AvailableSessionsModal;
